export { default as Plans1 } from './plans-1.svg';
export { default as Plans2 } from './plans-2.svg';
export { default as Plans3 } from './plans-3.svg';
export { default as Plans4 } from './plans-4.svg';
export { default as Plans5 } from './plans-5.svg';
